function storeLastCollectionBreadcrumb() {
  if (document.body.classList.contains("template-collection")) {
    // Store the current collection URL in localStorage
    localStorage.setItem("lastCollectionUrl", window.location.pathname);
  }
}
function insertSubcollectionBreadcrumb() {
  if (!document.body.classList.contains("template-product")) return;

  var lastCollectionUrl = localStorage.getItem("lastCollectionUrl");
  if (!lastCollectionUrl) return;

  var subcrumb = document.getElementById("js-subcollection-crumb");
  if (!subcrumb) return;

  // Parse subcollections JSON array
  var subcollections = [];
  try {
    var raw = subcrumb.dataset.subcollections || "[]";
    subcollections = JSON.parse(raw);
  } catch (e) {}

  var mainCollectionBreadcrumb = document.querySelector(".breadcrumbs-list__item.main-collection");
  if (!mainCollectionBreadcrumb || !subcollections.length) return;

  // Get main collection URL from the breadcrumb link
  var mainCollectionUrl = mainCollectionBreadcrumb.querySelector("a")?.getAttribute("href");
  if (!mainCollectionUrl) return;

  // Only add subcollection if lastCollectionUrl is different from mainCollectionUrl
  if (mainCollectionUrl !== lastCollectionUrl) {
    var sub = subcollections.find(function (c) {
      return c.url === lastCollectionUrl;
    });
    if (sub) {
      // Insert subcollection breadcrumb after the main collection breadcrumb
      var li = document.createElement("li");
			var icon = document.createElement("span");
			icon.className = "icon"
			icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation"><path d="m9 18 6-6-6-6"></path></svg>';
      li.className = "breadcrumbs-list__item sub-collection";
      li.innerHTML = '<a class="breadcrumbs-list__link" href="' + sub.url + '">' + sub.title + "</a> ";
			li.appendChild(icon);
      mainCollectionBreadcrumb.parentNode.insertBefore(li, mainCollectionBreadcrumb.nextSibling);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  storeLastCollectionBreadcrumb();
  insertSubcollectionBreadcrumb();
});
